import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";

export default {
  mixins: [AppLoadPageMixin],

  methods: {
    getLabel(instance) {
      return instance.name;
    }
  }
};
